export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api/v1';
export const SHOW_DEBUG_INFO = process.env.REACT_APP_SHOW_DEBUG_INFO === "true" || false;